import authApiSaga from '@spa/lib/store/sagas/api/auth/authApiSaga';
import cartApiSaga from '@spa/lib/store/sagas/api/cart-and-place-order/cartApiSaga';
import { fork } from 'typed-redux-saga';
import wishlistApiSaga from '@spa/lib/store/sagas/api/wishlist/whislistApiSaga';

function* apiSaga(): Generator {
  yield* fork(authApiSaga);
  yield* fork(cartApiSaga);
  yield* fork(wishlistApiSaga);
}

export default apiSaga;
